import React, { useEffect, useState } from "react";
import { Modal } from "@material-ui/core";
import classNames from "classnames";
import styles from "./BulkChangeLabelsModal.module.scss";
import Button from "../../button/Button";
import { toast } from "react-toastify";
import { CloseIcon } from "../../../assets";
import vendingControllersService from "../../../apis/services/admin/vendingControllersService";
import { TAX_LABEL_PDV, TAX_LABEL_NO_PDV } from "../../../util/itemPresets";

const BulkChangeLabelsModal = ({
  modalOpen,
  onClose,
  selectedControllers,
  onSuccess,
}) => {
  const [targetLabel, setTargetLabel] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!modalOpen) {
      setTargetLabel(null);
    }
  }, [modalOpen]);

  const onSubmit = async () => {
    if (saving || !targetLabel || selectedControllers.length === 0) {
      return;
    }
    setSaving(true);
    let changedItems = 0;
    let okControllers = 0;
    const failed = [];
    // Sekvencijalno po ESP-u: učitaj stavke pa promeni labelu svakoj;
    // greška na jednom ESP-u ne zaustavlja ostale.
    for (const controller of selectedControllers) {
      try {
        const { data } = await vendingControllersService.getVendingController({
          id: controller.id,
        });
        const items = data?.vendingController?.items || [];
        for (const item of items) {
          const labels = item.labels || [];
          if (labels.length === 1 && labels[0] === targetLabel) {
            continue;
          }
          await vendingControllersService.updateItem({
            id: controller.id,
            item: { ...item, labels: [targetLabel] },
          });
          changedItems += 1;
        }
        okControllers += 1;
      } catch (err) {
        failed.push({
          macAddress: controller.macAddress || `#${controller.id}`,
          message:
            err?.response?.data?.message || err?.message || "Nepoznata greška",
        });
      }
    }
    setSaving(false);
    if (failed.length === 0) {
      toast.info(
        `Poreska stopa → ${targetLabel}: promenjeno ${changedItems} stavki na ${okControllers} ESP uređaja`
      );
    } else {
      toast.warn(
        `Promenjeno ${changedItems} stavki (${okControllers}/${selectedControllers.length} ESP) — greška: ` +
          failed.map((f) => `${f.macAddress}: ${f.message}`).join("; ")
      );
    }
    onSuccess({
      changedItems,
      okControllers,
      failedControllers: failed.length,
    });
  };

  return (
    <Modal open={modalOpen} onClose={onClose}>
      <div className={styles.modalWrap}>
        <div className={styles.modalInner}>
          <div className={styles.header}>
            <div className={styles.closeIconWrap}>
              <img
                src={CloseIcon}
                alt="close"
                onClick={onClose}
                className={styles.closeIcon}
              />
            </div>
            <p className={styles.title}>
              Promeni poreske stope ({selectedControllers.length} ESP)
            </p>
          </div>
          <div className={styles.content}>
            <p className={styles.confirmText}>
              Menja poresku stopu, preko odgovarajuće poreske labele, na svim
              stavkama izabranih ESP uređaja (žetoni, pranja, usisavanja...).
              Nazivi, cene i identifikatori ostaju nepromenjeni.
            </p>
            <div className={styles.labelChoices}>
              <button
                type="button"
                className={classNames(
                  styles.labelButton,
                  targetLabel === TAX_LABEL_PDV && styles.labelButtonActive
                )}
                onClick={() => setTargetLabel(TAX_LABEL_PDV)}
              >
                {TAX_LABEL_PDV} — u PDV-u
              </button>
              <button
                type="button"
                className={classNames(
                  styles.labelButton,
                  targetLabel === TAX_LABEL_NO_PDV && styles.labelButtonActive
                )}
                onClick={() => setTargetLabel(TAX_LABEL_NO_PDV)}
              >
                {TAX_LABEL_NO_PDV} — nije u PDV-u
              </button>
            </div>
            <div className={styles.actions}>
              <Button
                name={saving ? "Menjam..." : "Potvrdi"}
                onClick={onSubmit}
                disabled={
                  saving || !targetLabel || selectedControllers.length === 0
                }
                showLoader={saving}
              />
              <Button name="Otkaži" onClick={onClose} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BulkChangeLabelsModal;
